/**
 * ISSUES BASELINE
 * Pure rule : while the questionnaire has unsaved changes, keep showing the problems that were already there
 * (they disappear as soon as they are fixed), and wait for the save to show the new ones.
 * Problems are compared by id : an id is stable (topic, question, kind of problem).
 */

export function getIssuesWhileEditing<T extends { id: string }>(
  issues: T[],
  baselineIds: string[],
  isEdited: boolean,
  isAlwaysVisible: (id: string) => boolean = () => false
): T[] {
  if (!isEdited) return issues
  return issues.filter((issue) => baselineIds.includes(issue.id) || isAlwaysVisible(issue.id))
}
